import React from 'react'
import cn from 'classnames'

import Favorite from 'app/components/SVGS/Favorite'

import './styles.scss'

const bc = 'add-to-favorites'

const AddToFavorites = ({
  t,
  isYesterday = false,
  activityId,
  addToFavorites,
  removeFromFavorites,
  highlightFavoriteIcon,
  customClass,
  customIconClass,
  showText = true,
  title,
}) => (
  <div
    className={cn(bc, {
      [`${bc}--active`]: highlightFavoriteIcon,
      [customClass]: customClass,
    })}
    onClick={() => {
      if (highlightFavoriteIcon) {
        removeFromFavorites({ activityId, isYesterday })
      } else {
        addToFavorites({ activityId, isYesterday })
      }
    }}
  >
    <span title={title} className={cn(`${bc}__icon`, { [customIconClass]: customIconClass })}>
      <Favorite />
    </span>
    {showText && (
      <div className={`${bc}__text`}>{t(`${highlightFavoriteIcon ? 'Remove from' : 'Add to'} favorites`)}</div>
    )}
  </div>
)

export default AddToFavorites
